export default "/images/vendor/flag-icon-css/flags/1x1/ag.svg?3f18bb58815f1eb37b603c82f58bb62e";